var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,8V20.18945l-4.71973-4.71972-1.06054,1.06054,6,6a.74971.74971,0,0,0,1.06054,0l6-6-1.06054-1.06054L40.75,20.18945V8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20,66.75H61.667a9.08325,9.08325,0,0,0,0-18.1665,8.88462,8.88462,0,0,0-4.49023,1.21875,17.404,17.404,0,0,0-33.251-3.80127A10.58906,10.58906,0,0,0,20,45.25a10.75,10.75,0,0,0,0,21.5Zm0-20a9.1545,9.1545,0,0,1,4.01562.92773.7491.7491,0,0,0,1.03126-.41992,15.9031,15.9031,0,0,1,30.79394,3.91455.75047.75047,0,0,0,1.207.52344A7.48766,7.48766,0,0,1,61.667,50.0835a7.58325,7.58325,0,0,1,0,15.1665H20a9.25,9.25,0,0,1,0-18.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25,20V30a.7502.7502,0,0,0,.75.75H60a.7502.7502,0,0,0,.75-.75V20h-1.5v9.25H20.75V20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVStorage);
export default __webpack_public_path__ + "static/media/icon_v_storage.e71d21d93745b4b853f4e6171588ce3b.svg";
export { ForwardRef as ReactComponent };